import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
// import Navbar from '../components/Navbar'
import PropTypes from 'prop-types'
import Appbar from '../components/Appbar'
import { Button, Box, Container, useTheme, useMediaQuery } from '@mui/material'
import LoginModal from '../components/modals/LoginModal'
import { useTranslation } from 'react-i18next'

const GetStarted = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const { t } = useTranslation()

  const handleClick = () => {
    setIsLoginModalOpen(true)
  }
  const closeModals = () => {
    setIsLoginModalOpen(false)
  }

  return (
        <Box
      component="main"
      sx={{
        // ensure background covers entire scrolling area
        background: 'radial-gradient(circle, rgba(239,249,250,1) 0%, rgba(148,187,233,1) 100%)',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',

        // always at least full viewport tall, and scroll vertically if content overflows
        minHeight: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      <Appbar />

      <Container
        sx={{
          // fill remaining height of viewport (minus Appbar) if needed
          height: `calc(100vh - ${isMobile ? 56 : 84}px)`,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          px: 2,
          py: 3
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            width: '100%',
            textAlign: 'center',
            pt: 16,
            pb: 16
          }}
        >
          <Typography variant="h3" gutterBottom sx={{
            overflowWrap: 'break-word',
            wordBreak: 'break-word'
          }}>
            {t('landing_title')}
          </Typography>

          <Typography
            variant="h5"
            gutterBottom
            sx={{ pt: 2, pb: 2 }}
          >
            {t('landing_content')}
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={handleClick}
          >
            {t('sign_in')}
          </Button>
        </Box>
      </Container>

      <LoginModal
        isOpen={isLoginModalOpen}
        handleClose={closeModals}
      />
    </Box>
  )
}

GetStarted.propTypes = {
  user: PropTypes.object
}

export default GetStarted
